import React from 'react';
import { useLang } from '../../i18n/context';
import type { TabId } from '../../types';

const MAIL = ['riddimradar', 'proton.me'].join('@');

export function Footer({ onTabChange }: { onTabChange: (tab: TabId) => void }) {
  const { t } = useLang();
  const linkStyle: React.CSSProperties = {
    background: 'none', border: 'none', padding: 0, cursor: 'pointer',
    color: 'var(--text-muted)', fontSize: '12px', fontFamily: 'inherit', textDecoration: 'none',
  };
  return (
    <footer style={{
      borderTop: '1px solid rgba(201,168,76,0.15)', marginTop: '32px',
      padding: '12px 16px', display: 'flex', flexWrap: 'wrap', alignItems: 'center',
      justifyContent: 'center', gap: '6px 18px', textAlign: 'center',
    }}>
      <button style={linkStyle} onClick={() => onTabChange('legal')}
        onMouseEnter={e => { (e.currentTarget as HTMLElement).style.color = '#c9a84c'; }}
        onMouseLeave={e => { (e.currentTarget as HTMLElement).style.color = 'var(--text-muted)'; }}>
        {t('footer.legal')}
      </button>
      <button style={linkStyle} onClick={() => onTabChange('privacy')}
        onMouseEnter={e => { (e.currentTarget as HTMLElement).style.color = '#c9a84c'; }}
        onMouseLeave={e => { (e.currentTarget as HTMLElement).style.color = 'var(--text-muted)'; }}>
        {t('footer.privacy')}
      </button>
      <a href={`mailto:${MAIL}`} style={linkStyle}
        onMouseEnter={e => { (e.currentTarget as HTMLElement).style.color = '#c9a84c'; }}
        onMouseLeave={e => { (e.currentTarget as HTMLElement).style.color = 'var(--text-muted)'; }}>
        {t('footer.contact')}
      </a>
    </footer>
  );
}
